import Vue from 'vue/dist/vue.esm'
import template from './scoring_row_template.slim'

Vue.component('scoring-row', {
  mixins: [template],
  props: [
    'is_selected',
    'update_score',
    'score_band',
    'score_colors_and_fills',
    'new_tracking_interface',
    'mastery_level_texts'
  ],
  computed: {
    scoreMap() {
      if (!this.mastery_level_texts || !this.mastery_level_texts.length) {
        let scoreBand = Number.parseInt(this.score_band);
        return [
          scoreBand === 5 ? { display: 'exemplary', value: 4, class: 'exemplary', color: this.score_colors_and_fills[4].color, fill: this.score_colors_and_fills[4].fill } : null,
          { display: 'yes', value: 3, class: 'yes', color: this.score_colors_and_fills[3].color, fill: this.score_colors_and_fills[3].fill },
          { display: 'mostly', value: 2, class: 'mostly', color: this.score_colors_and_fills[2].color, fill: this.score_colors_and_fills[2].fill },
          { display: 'somewhat', value: 1, class: 'somewhat', color: this.score_colors_and_fills[1].color, fill: this.score_colors_and_fills[1].fill },
          scoreBand > 3 ? { display: 'not yet', value: 0, class: 'no', color: this.score_colors_and_fills[0].color, fill: this.score_colors_and_fills[0].fill } : null
        ].filter(score => score !== null)
      }

      const getDisplayClass = (score) => {
        const classMap = {
          4: 'exemplary',
          3: 'yes',
          2: 'mostly',
          1: 'somewhat',
          0: 'no'
        };
        return classMap[score] || 'no';
      };

      return this.mastery_level_texts.map(item => ({
        value: item.score,
        class: getDisplayClass(item.score),
        color: this.score_colors_and_fills[item.score].color,
        fill: this.score_colors_and_fills[item.score].fill,
        mastery_level_text: item.formatted_body
      })).sort((a, b) => b.value - a.value);
    }
  },
})
